

import { get, post } from './http'
const campaignPath = '/operating-platform/campaign/frontend/lottery-activity'

// 周年庆
export default { 


  // 抽奖
  onLottery: (params) => {
    return post(`${campaignPath}/draw`, params)
  },
  // 我的奖品
  getMyPrizeList: (params) => {
    return get(`${campaignPath}/user/my-winning`, params)
  },
  // 查询最近提交的收货地址
  getRecentAdd: (params) => {
    return get(`${campaignPath}/delivery/last`, params)
  },
  // 提交收货地址
  submitAdd: (params) => {
    return post(`${campaignPath}/delivery/fill-in`, params)
  },
}